// extracted by mini-css-extract-plugin
export default {"homeVideoContent":"logo_animation_homeVideoContent__3xEDi","coinBlastReward":"logo_animation_coinBlastReward__GxHmI"};